export interface OnboardingCollectiviteWorkflow {
    Code?: string,
    Libelle?: string,
    Order?: number
}

const IDENTIFICATION_COLLECTIVITE: string = "IDC"
const VERIFICATION: string = "VER"
const ADRESSES: string = "ADD"
const PIECE_JUSTIFICATIVE: string = "PJS"
const REPRESENTANTS: string = "REP"
const COMPLET: string = "CPL"

export const OnboardingCollectiviteWorkflow = {
    IDENTIFICATION_COLLECTIVITE,
    VERIFICATION,
    ADRESSES,
    PIECE_JUSTIFICATIVE,
    REPRESENTANTS,
    COMPLET
}